import { render, staticRenderFns } from "./payalert.vue?vue&type=template&id=edf57110&scoped=true"
import script from "./payalert.vue?vue&type=script&lang=js"
export * from "./payalert.vue?vue&type=script&lang=js"
import style0 from "./payalert.vue?vue&type=style&index=0&id=edf57110&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf57110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edf57110')) {
      api.createRecord('edf57110', component.options)
    } else {
      api.reload('edf57110', component.options)
    }
    module.hot.accept("./payalert.vue?vue&type=template&id=edf57110&scoped=true", function () {
      api.rerender('edf57110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/payalert.vue"
export default component.exports